import { render } from "./Gateway.vue?vue&type=template&id=1c7a1310"
import script from "./Gateway.vue?vue&type=script&lang=js"
export * from "./Gateway.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__